import { render, staticRenderFns } from "./ReplyMessageList.vue?vue&type=template&id=4b24463a&scoped=true&"
import script from "./ReplyMessageList.vue?vue&type=script&lang=js&"
export * from "./ReplyMessageList.vue?vue&type=script&lang=js&"
import style0 from "./ReplyMessageList.vue?vue&type=style&index=0&id=4b24463a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b24463a",
  null
  
)

export default component.exports